export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PAGE_SIZE = 8;

export const slugifyMedia = (name) =>
  (name || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "medio";

export const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1586880244406-556ebe35f282?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const formatApiError = (detail, fallback = "Algo salió mal. Inténtalo de nuevo.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const formatDate = (iso) => {
  if (!iso) return "Sin fecha";
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "Sin fecha";
  }
};

export const timeAgo = (iso) => {
  if (!iso) return "Nunca actualizado";
  const diff = Date.now() - new Date(iso).getTime();
  if (isNaN(diff)) return "Nunca actualizado";
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Actualizado ahora mismo";
  if (mins < 60) return `Actualizado hace ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `Actualizado hace ${hours} h`;
  const days = Math.floor(hours / 24);
  return `Actualizado hace ${days} d`;
};
